import React, { useState } from 'react';
import { X, Maximize2, Minimize2, BellRing, CheckCircle2, AlertTriangle } from 'lucide-react';
import './NoticesPanel.css';

export interface NoticeItem {
  /** ISO 8601. */
  timestamp: string;
  /** Que se hizo y a quien: "Email a x@y.com". */
  channel: string;
  /** El correo no salio. */
  failed?: boolean;
}

interface NoticesPanelProps {
  title: string;
  subtitle?: string;
  items: NoticeItem[];
  onClose: () => void;
}

/**
 * Historial de avisos en un panel lateral. Entra por la derecha y se puede
 * ampliar a pantalla completa con el boton de la cabecera; vuelve a su ancho con
 * el mismo boton. Mismo aspecto que el visor de documentos (cabecera con icono,
 * boton redondo de cierre, pie con acciones).
 */
export function NoticesPanel({ title, subtitle, items, onClose }: NoticesPanelProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="al-modal-root np-root">
      <div className="al-modal-backdrop" onClick={onClose} />
      <aside className={`np-card${expanded ? ' np-card--full' : ''}`} aria-label={title}>
        <div className="np-header">
          <div className="np-header-left">
            <div className="np-icon"><BellRing size={22} /></div>
            <div>
              <h3 className="np-title">{title}</h3>
              {subtitle && <p className="np-subtitle">{subtitle}</p>}
            </div>
          </div>
          <div className="np-header-actions">
            <button
              onClick={() => setExpanded(v => !v)}
              className="np-round-btn"
              aria-label={expanded ? 'Reducir a panel lateral' : 'Ampliar a pantalla completa'}
              title={expanded ? 'Reducir' : 'Pantalla completa'}
              data-testid="np-expand"
            >
              {expanded ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
            </button>
            <button onClick={onClose} className="np-round-btn" aria-label="Cerrar"><X size={22} /></button>
          </div>
        </div>

        <div className="np-body">
          {items.length === 0 ? (
            <p className="np-empty">Todavía no se ha avisado al cliente.</p>
          ) : (
            items.map((item, i) => (
              <div key={i} className={`np-item${item.failed ? ' np-item--failed' : ''}`}>
                <div className="np-item-icon">
                  {item.failed ? <AlertTriangle size={18} /> : <CheckCircle2 size={18} />}
                </div>
                <div className="np-item-text">
                  <span className="np-item-channel">{item.channel}</span>
                  <span className="np-item-time">{new Date(item.timestamp).toLocaleString('es-ES')}</span>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="np-footer">
          <button onClick={onClose} className="np-btn">Cerrar</button>
        </div>
      </aside>
    </div>
  );
}
